<template>
  <v-sheet color="background">
    <v-row dense>
      <v-col>
        <v-skeleton-loader class="mx-auto" type="heading" />
      </v-col>
    </v-row>
    <v-row dense class="mt-4" v-for="n in 2" :key="`row1_${n}`">
      <v-col cols="4">
        <v-skeleton-loader type="list-item" />
      </v-col>
      <v-col cols="4">
        <v-skeleton-loader type="list-item" />
      </v-col>
      <v-col cols="4">
        <v-skeleton-loader type="list-item" />
      </v-col>
    </v-row>
    <div v-for="n in 2" :key="`row2_${n}`">
      <v-row class="mt-6">
        <v-col>
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
      <v-row dense class="mt-6">
        <v-col cols="4">
          <v-skeleton-loader type="list-item" />
        </v-col>
        <v-col cols="4">
          <v-skeleton-loader type="list-item" />
        </v-col>
      </v-row>
    </div>
    <v-row class="mt-6">
      <v-col>
        <v-skeleton-loader class="mx-auto" type="heading" />
      </v-col>
    </v-row>
    <v-row class="mt-6">
      <v-col>
        <v-skeleton-loader class="mx-auto" type="image" />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: 'SkeletonCadastroWebhook',
}
</script>
